<template>
    <div class="content">
        <div class="left">
            <div class="left_img">
                <img class="img" style="margin-left: 25px;margin-top: -30px;" src="../../assets/pcb.png">
                <img class="img" src="../../assets/pc.jpg">
            </div>
        </div>
        <div class="right">
            <div class="right_wrap" >
                <div class="title">PC助手·九阴全系列解决方案</div>
                <div class="desc"  style="font-size:23px">全方位的、便捷的30多项功能祝你江湖无忧!</div>
                <div class="desc" style="margin-top: -120px;font-size:23px">
                    使用C#语言编程,以30帧对屏幕截图并判断逻辑,配合鼠标宏操作<br/><br/>
                    最大程度模拟真人操作,不读不改内存,安全可靠<br/><br/>
                    支持win7、win10、win11系统,不绑定电脑,微信扫码登录<br/><br/>
                    win7后台操作,可以多开, win10、win11前台操作,单开占用键盘鼠标<br/><br/>
                </div>

                <div class="btn_wrap">
                    <div class="btn" @click="pcClick()">
                        PC助手下载
                    </div>
                    <div class="btn" @click="newClick()">
                        新手教程
                    </div>
                    <div class="btn" @click="tastClick()">
                        任务平台
                    </div>
                </div>

                <div class="btn_desc">#win7系统支持后台多开、win10、win11系统前台使用(免费下载、仅限九阴PC助手会员使用)</div>
<!--                <div class="btn_desc">仅限九阴PC助手会员使用</div>-->
            </div>
        </div>
<!--        <div class="foot" id="foot">Copyright ? 2023-2024ICP证:-->
<!--&lt;!&ndash;            <a href="https://beian.miit.gov.cn/" target="_blank">辽ICP备2022004881号-1 </a>&ndash;&gt;-->
<!--            <a href="https://beian.miit.gov.cn/" target="_blank">辽ICP备20002243号-1 </a>-->
<!--            负责人邮箱: 34543686@qq.com</div>-->
    </div>
</template>

<script>
    export default {
        data() {
            return {
            }
        },
        computed:{
        },
        watch: {
        },
        methods:{

            tastClick(){
                window.open("https://www.ookan.com/jy/plan");
            },

            pcClick(e){

                this.$message.success("程序下载中...");
                this.$tools.downloadAssistant();

                // this.$confirm("请选择下载方式(如果加速不可用就只能用普通)", {
                //     confirmButtonText: '加速下载',
                //     cancelButtonText: '普通下载',
                //     type: 'warning'
                // }).then(() => {
                //     this.$message.success("程序下载中...");
                //     location.href = this.$tools.url1;
                // }).catch((e) =>{
                //     //新建订单
                //     if(e == 'cancel'){
                //         this.$message.success("程序下载中...");
                //         location.href = this.$tools.url;
                //     }
                // })

            },

            newClick(){
                localStorage.setItem("tokenName","t");
                localStorage.setItem("tokenValue","ghkshfjdhkjfhdskjhsjhfuiwf");
                this.$router.push({ name:'home' });
            }

        },

        mounted() {
            if(document.documentElement.clientWidth <= 1000){
                this.$confirm("检测当前分辨率较小,内容显示可能不完全", {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    type: 'warning'
                })
                return;
            }
            let u = navigator.userAgent;
            console.log('uuu', u)
            //如果是edge
            if(u.indexOf('Edge') > -1 || u.indexOf('Edg') > -1){
                this.$confirm("检测到Edge浏览器,此浏览器如果拦截下载,需要更换浏览器!", {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    type: 'warning'
                })
                return;
            }
        }
    };
</script>

<style scoped>
    .content{
        position: relative;
        width: 100vw;
        height: 100vh;
        min-height: 600px;
        min-width: 1300px;
        background: rgba(255, 253, 254, 0.97);
    }
    .left{
        position: absolute;
        left: 0;
        top: 0;
        width: 50%;
        height: 100%;
        transition: all 0.5s ease-in-out;
    }
    .left_img{
        position: absolute;
        left: 0;
        right: 0;
        top: 20vh;
        margin: auto;
        height: 520px;
        width: 595px;
        box-shadow: 0 2px 8px rgba(173, 173, 173, 0.5);
        border-radius: 10px;
    }
    .img{
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        border-radius: 10px;
    }

    .right{
        position: absolute;
        right: 0;
        top: 0;
        width: 50%;
        height: 100%;
        transition: all 0.5s ease-in-out;
    }
    .right_wrap{
        position: absolute;
        right: 0;
        top: 20vh;
        width: 100%;
        height: 50%;
        transition: all 0.5s ease-in-out;
    }

    .title{
        position: relative;
        height: 50px;
        width: 100%;
        font-weight: 550;
        font-size: 34px;
        line-height: 45px;
        color: rgba(0,0,0,.8);
        display: flex;
        align-items: center;
        justify-content: start;
    }
    .desc{
        position: relative;
        width: 100%;
        font-size: 16px;
        line-height: 142%;
        color: rgba(0,0,0,.6);
        margin-top: 12px;
        margin-bottom: 170px;
        display: flex;
        align-items: center;
        justify-content: start;
    }

    .btn_wrap{
        position: relative;
        display: flex;
        justify-content: start;
        align-items: center;
        margin-top: -130px;
    }
    .btn{
        position: relative;
        flex: none;
        border-radius: 8px;
        font-size: 16px;
        line-height: 20px;
        color: #fff;
        width: 190px;
        height: 52px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f60;
        font-weight: 800;
        margin-right: 30px;
    }
    .btn:hover{
        cursor: pointer;
        opacity: 0.8;
    }
    .btn_icon{
        width: 20px;
        height: 20px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 50%;
        background-image: url(//res.orayimg.com/sunlogin/1.0/img/cd57228.png);
        margin-right: 8px;
    }
    .btn_desc{
        position: relative;
        text-align: left;
        margin-top: 12px;
        font-size: 12px;
        line-height: 16px;
        color: rgba(0,0,0,.4);
        display: flex;
        align-items: center;
        justify-content: start;
    }

    .foot{
        position: absolute;
        height: 30px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #777777;
        bottom: 0;
    }

</style>
